import React, {useRef, useState, useEffect, Fragment} from 'react'
import pdfTronViewer from '@pdftron/webviewer'
import {getInstance} from '@pdftron/webviewer'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Custom Style
import {Alert} from '../Alert/Alert'
import webViewerStyle from '../../styles/jss/components/webViewer/webViewerStyle'

// Global Function
import {webViewerDRSaveAnnotation} from "../../global/webViewerDRSaveAnnotation"

import {getAnnotation} from '../../dataSource/webViewer'


const useStyles = makeStyles(theme => webViewerStyle(theme))

const WebViewerDRRelatedItem = props => {
	const {property, relatedItemSaveResult, setSelectedRelatedItemSeq, withChangeManagement, openCreateDialog, openViewDialog} = props
	const classes = useStyles()
	const store = require('store')
	const drViewerDiv = useRef(null)

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}


	
	useEffect(() => {
		pdfTronViewer({
			path: process.env.REACT_APP_PDFTRON_PATH,
			licenseKey: process.env.REACT_APP_PDFTRON_LICENSE_KEY,
			// initialDoc: 'https://pdftron.s3.amazonaws.com/downloads/pl/webviewer-demo.pdf'
		}, drViewerDiv.current). then(instance => {
			const {annotationPopup, annotManager, docViewer} = instance
  
			const annotationMenuBtn = [{
				type: 'actionButton',
				label: "",
				dataElement: 'relatedItemElement',
				onClick: null,
			}]
			// Add all custom buttons to the annotationPopup beforehand 
			annotationPopup.add(annotationMenuBtn)


			docViewer.on('documentLoaded', () => {
				docViewer.zoomTo(0.5)

				annotManager.on('annotationChanged', (annotations, action, {imported}) => {
					if (imported) {
						store.set('annotActive', false)
					}
					else if (action === 'add') {
						console.log('this is a change that added annotations')
						console.log("action => add || annotActive => " + store.get('annotActive'))

						store.set('annotActive', true)
					}
					else if (action === 'modify') {
						console.log('this change modified annotations')
						console.log("action => modify || annotActive => " + store.get('annotActive'))

						store.set('annotActive', true)
					}
					else if (action === 'delete') {
						console.log('there were annotations deleted')
						console.log("action => delete || annotActive => " + store.get('annotActive'))

						store.set('annotActive', true)
					}
				})
			})


			docViewer.on('annotationsLoaded', () => {
				const annotations = annotManager.getAnnotationsList()

				annotations.map(() => {
					instance.setAnnotationContentOverlayHandler(annotation => {
						const div = document.createElement('div')
						div.appendChild(document.createTextNode(`Item Type: ${annotation.getCustomData("relativeSeq").type_name}`))
						div.appendChild(document.createElement('br'))
						div.appendChild(document.createTextNode(`Ref No.: ${annotation.getCustomData("relativeSeq").rel_no}`))
						return div
					})
				})
			})


			annotManager.on('annotationSelected', (annotations, action) => {
				if (action === 'selected') {
					const annotStringArray = annotManager.getSelectedAnnotations()

					setSelectedRelatedItemSeq(annotStringArray[0].getCustomData("relativeSeq").relative_seq)

					if (annotStringArray[0].getCustomData("relativeSeq") === "") {
						instance.updateElement('relatedItemElement', {
							type: 'actionButton',
							title: 'Create New Item',
						 	label: <img src={require('../../img/add.png')} />,
							onClick: openCreateDialog,
						})
					}
					else {
						instance.updateElement('relatedItemElement', {
							type: 'actionButton',
							title: 'View Item',
						 	label: <img src={require('../../img/view.png')} />,
							onClick: openViewDialog,
						})
					}
				}
			})

		})
	}, [])



	useEffect(() => {
		const instance = getInstance(drViewerDiv.current)

		// const {annotationPopup, annotManager, docViewer} = instance

		if (property) {
			getAnnotation({
				file_ref: property.file_ref,
				file_cat: property.file_cat
			}).then(annotString => {
				instance.loadDocument(
					// `${process.env.REACT_APP_API_URL_3002}/file/download?file_cat=${property.file_cat}&file_ref=${property.file_ref}`, {
					`${process.env.REACT_APP_API_URL_3002}/file/download?file_cat=${property.file_cat}&file_ref=${property.file_ref}&annot=${false}`, {

						filename: property.file_name,
		
						customHeaders: {
							"Authorization": "Bearer " + store.get('access_token'),
							"site": store.get('site'),
							"locale": store.get('locale')
						}
					}
				)

				instance.docViewer.on('documentLoaded', () => {
					if (annotString.data) {
						instance.annotManager.deleteAnnotations(instance.annotManager.getAnnotationsList())
						if (annotString.data.annotation !== "") {
							instance.annotManager.importAnnotations(annotString.data.annotation)
						}
						store.set('annotActive', false)
					}
				})
			})
		}
	}, [property])



	useEffect(() => {
		const instance = getInstance(drViewerDiv.current)

		if (instance) {
			const {annotManager} = instance
			
			webViewerDRSaveAnnotation(instance, property.file_cat, property.file_ref)

			if (withChangeManagement) {
				const annotStringArray = annotManager.getSelectedAnnotations()

				if (annotStringArray.length > 0) {
					const annotString = annotStringArray[0]
					annotString.setCustomData("relativeSeq", relatedItemSaveResult)

					instance.updateElement('relatedItemElement', {
						type: 'actionButton',
						title: 'View Item',
						label: <img src={require('../../img/view.png')} />,
						onClick: openViewDialog,
					})

					setSelectedRelatedItemSeq(annotStringArray[0].getCustomData("relativeSeq").relative_seq)
				}
			}
			
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "All Annotation change have been save."
			})
		}
	}, [relatedItemSaveResult])


	return (
		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>
			</div>

			<div className="webviewer" ref={drViewerDiv} className={classes.webViewer}></div>
		</Fragment>
	)
}

export default WebViewerDRRelatedItem